import { CircularProgress } from "@mui/material";

import Suspense from "@/components/molecules/Suspense";
import { IMedia } from "@/interfaces/media.interface";
import { CurrentChatMessages } from "@/messages/chat/current-chat.messages";

import MediaComponent from "../MediaComponent";

interface DisplayMediaProps {
  media: IMedia | null;
  messages: CurrentChatMessages;
  isLoading: boolean;
  mediaURL: string | null;
  isSentByUser: boolean;
}

const DisplayMedia: React.FC<DisplayMediaProps> = ({
  media,
  messages,
  isLoading,
  mediaURL,
  isSentByUser,
}) => {
  const mediaType = media?.type?.split("/")[0];

  if (isLoading || !mediaURL || !media) {
    return <CircularProgress sx={{ fontSize: 30, color: "white" }} />;
  }

  const isLoadingMedia = isLoading || !mediaURL || !media;

  return (
    <Suspense isSuspended={!!isLoadingMedia} fallback={<CircularProgress size={50} />}>
      <MediaComponent
        mediaType={mediaType}
        mediaURL={mediaURL}
        media={media}
        messages={messages}
        isSentByUser={isSentByUser}
      />
    </Suspense>
  );
};

export default DisplayMedia;
